import axios from '../utils/axios';

export default function updateCENote(adminId, id, data) {
    return (
        axios.post('/admin/' + adminId +'/client-engagement/notes/' + id + '/update',  data )
    )
}